"use strict";

exports.__esModule = true;
exports.HistogramDefinition = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/* eslint-disable */

var HistogramDefinition = exports.HistogramDefinition = function HistogramDefinition(translate) {
  return {
    columns: [{
      id: "range",
      name: translate("DataTable.Column.Title.Range", "Range"),
      type: "range",
      enableSorting: true,
      sanitizedFieldName: "Range"
      // sortMethod: (a, b) => Number(b) - Number(a)
    }, {
      id: "count",
      enableSorting: true,
      name: translate("DataTable.Column.Title.count", "Count"),
      type: "number",
      sanitizedFieldName: "Count"
      // sortMethod: (a, b) => Number(b) - Number(a)
    }, {
      id: "duration_sum",
      enableSorting: true,
      name: translate("DataTable.Column.Title.total_duration", "Total Duration"),
      type: "duration",
      sanitizedFieldName: "Total Duration"
      // sortMethod: (a, b) => Number(b) - Number(a)
    }],
    rowFormatters: [],
    parseData: {},
    createDefault: function createDefault() {
      return {
        enablePagination: true,
        overFetchAll: false,
        defaultPageSize: "auto",
        columns: [{
          id: "range",
          name: translate("DataTable.Column.Title.Range", "Range"),
          type: "range",
          enableSorting: true,
          sanitizedFieldName: "Range"
          // sortMethod: (a, b) => Number(b) - Number(a)
        }, {
          id: "count",
          enableSorting: true,
          name: translate("DataTable.Column.Title.count", "Count"),
          type: "number",
          sanitizedFieldName: "Count"
          // sortMethod: (a, b) => Number(b) - Number(a)
        }, {
          id: "duration_sum",
          enableSorting: true,
          name: translate("DataTable.Column.Title.total_duration", "Total Duration"),
          type: "duration",
          sanitizedFieldName: "Total Duration"
          // sortMethod: (a, b) => Number(b) - Number(a)
        }]
      };
    }
  };
};